function EventsControls() {
    "use strict";

    this.CardView = null;
    this.CardViewTimer = null;
    this.CardViewFilter = null;
    this.CardViewPaginator = null;
    this.Map = null;
    this.MapLocate = null;
    this.MapSettingsListView = null;
    this.PlaybackControl = null;

    this.TrackpointCardView = null;
    this.TrackpointCardViewFilter = null;

    this.EventsListView = null;
    this.LegendDropdown = null;
    this.DetailsDropdown = null;
    this.LocateDropdown = null;
    this.NotesDropdown = null;
    this.SettingsDropdown = null;

    this.NotesManager = null;
    this.NotificationPanel = null;

    this.MapSettingState = null;
    this.PlaybackControl = null;
}
if (typeof exports !== 'undefined') {
    module.exports = EventsControls;
}